export default __webpack_public_path__ + "static/media/check.0539633c.svg";